<template>
  <div class="pb-10">

    <v-row class="mb-1 text-left">
      <v-col cols="6" md="3">
        <p class="page-title text-left fs-16">{{ $lang.NAME }}</p>
        <p class="secondary-text"> {{ payout_details.agent_name }}</p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.TYPE }}</p>
        <p class="secondary-text"> {{ payout_details.agent_type }}</p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.TOTA_EARNING }}</p>
        <p class="secondary-text">
          <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
          {{ payout_details.amount }}
        </p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.DEDUCTION_AMOUNT }}</p>
        <p class="secondary-text">
          <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
          {{ payout_details.deduction_amount }}
        </p>
      </v-col>

      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.PHONE_NUMBER }}</p>
        <p class="secondary-text"> {{ payout_details.agent_phone_number }}</p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.IFSC }}</p>
        <p class="secondary-text"> {{ payout_details.agent_bank_ifsc }}</p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="page-title fs-16 text-left">{{ $lang.ACCOUNT_NUMBER }}</p>
        <p class="secondary-text"> {{ payout_details.agent_bank_account_number }}</p>
      </v-col>
    </v-row>
    <v-row class="mb-1 text-left">
      <v-col cols="6" md="4">
        <p class="page-title fs-16 text-left">{{ $lang.TRANSACTION_SUMMARY }}:</p>
        <v-row class="mb-1 text-left">
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text text-left"> {{ $lang.TOTA_EARNING }}</p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text text-right">
              <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
              {{ payout_details.amount }}
            </p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text">{{ $lang.TDS }}</p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text text-right">(-)
              <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
              {{ payout_details.tds }}
            </p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text">{{ $lang.TRANSACTION_CHARGE }}</p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text  text-right">(-)
              <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
              {{ payout_details.transaction_charge }}
            </p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text">{{ $lang.DEDUCTION_AMOUNT }}</p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="secondary-text  text-right"> (-)
              <v-icon color="#4F4D4D" size="15" style="margin:0px -3px 3px 2px">mdi-currency-inr</v-icon>
              {{ payout_details.deduction_amount }}
            </p>
          </v-col>
        </v-row>
        <v-divider>
        </v-divider>
        <v-row class="mb-1 text-left">
          <v-col class="py-1" cols="6" md="6">
            <p class="page-title text-left fs-14">{{ $lang.TOTAL }}</p>
          </v-col>
          <v-col class="py-1" cols="6" md="6">
            <p class="page-title text-right fs-14">
              <v-icon color="black" size="16" style="margin:0px -4px 3px 2px">mdi-currency-inr</v-icon>
              {{ payout_details.payout_amount }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


    <!--  -->
    <div v-if="payout_details.agent_type==$keys.DELIVERY_AGENT">
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="trip_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
      >

        <template v-slot:item.verification="{ item }">
          <v-icon v-if="item.is_active" color="#27AE60">
            mdi-check
          </v-icon>
          <v-icon v-else color="error">
            mdi-window-close
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="$router.push({name:'dispatch-details',params:{trip_id:encript(item.trip_id)}})">
            <img alt="" src="@/assets/arrow-right.svg">
          </v-btn>
        </template>

        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_TRIP" :type="$keys.EMPTY_TYPE_2"/>
        </template>
      </v-data-table>
    </div>
    <div v-else>
      <v-data-table
          :disable-sort="true"
          :headers="shipment_list_headers"
          :hide-default-footer="true"
          :items="shipment_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
      >

        <template v-slot:item.verification="{ item }">
          <v-icon v-if="item.is_active" color="#27AE60">
            mdi-check
          </v-icon>
          <v-icon v-else color="error">
            mdi-window-close
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="gotoShipmentDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg">
          </v-btn>
        </template>

        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_SHIPMENTS" :type="$keys.EMPTY_TYPE_2"/>
        </template>
      </v-data-table>
    </div>
    <v-pagination
        v-model="page_number"
        :length="total_page_count"
        :total-visible="7"
        class="custome-pagination"
        @input="getpayout_details"
    ></v-pagination>
  </div>
</template>


<script>
export default {
  components: {},
  data() {
    return {
      order_id: "",
      payout_details: {},
      shipment_list: [],
      trip_list: [],
      page_number: 1,
      total_page_count: 1,
      table_loading: false,
      headers: [
        {text: 'Trip ID', align: 'start', value: 'trip_id'},
        {text: 'Date', value: 'created_date'},
        {text: 'Line', value: 'line_name'},
        {text: 'Earning', value: 'earning'},
        {text: 'Shipment count', value: 'shipment_count'},
        {text: 'Num of stops', value: 'num_of_stops'},
        {text: '', value: 'action', align: 'end', width: "180px"},
      ],
      shipment_list_headers: [
        {text: 'Shipment ID', align: 'start', value: 'shipment_id'},
        {text: 'Date', value: 'shipment_date'},
        {text: 'Earning', value: 'earning'},
        {text: 'Wholesaler', value: 'wholesaler_firm_name'},
        {text: '', value: 'action', align: 'end', width: "180px"},
      ]
    }
  },
  created() {
    console.log(this.decrypt(this.$route.params.order_id))
    this.order_id = this.decrypt(this.$route.params.order_id)
    this.getpayout_details()
  },
  methods: {
    /* get  agent list */
    getpayout_details() {
      const self = this
      self.filter_agent_type = status
      let params = {
        order_id: self.order_id,
        page_number: this.page_number
      };

      self.table_loading = true;
      const successHandler = (response) => {
        self.payout_details = response.data.payout_details
        self.total_page_count = response.data.total_page_count
        if (self.payout_details.agent_type == this.$keys.PICKUP_AGENT)
          this.shipment_list = response.data.shipment_list
        else
          this.trip_list = response.data.trip_list

      };
      const finallyHandler = () => {
        self.table_loading = false
      };
      self.request_GET(self, self.$urls.GET_PAYOUT_DETAILS, params, successHandler, null, null, finallyHandler)
    },
  }
}
</script>